export default "__VITE_ASSET__G2lI5Rrn__"